if(!window.theme._registeredSections['announcement'] === true){
  theme.Announcement = (function() {

    function Announcement(container) {
      const scope = (container && container.querySelector) ? container : document;
      const announcementBar = scope.querySelector('.announcement__content-wrapper');

      if (document.body.classList.contains('menu-is-expanded') && announcementBar) {
        // Desktop hides the bar while the menu is open (legacy), so the
        // carousel is torn down there. On mobile the bar stays visible
        // (DSP-1589) — leave it running.
        var gridMedium = Number((window.theme && theme.settings && theme.settings.grid_medium) || 768);
        if (window.innerWidth >= gridMedium && announcementBar.classList.contains('slick-initialized')) {
          $(announcementBar).slick('unslick');
        }
      } else if (announcementBar && !announcementBar.classList.contains('slick-initialized')) {
        const slideSpeed = announcementBar.getAttribute('data-slide-animation-speed') || 3000;
        const autoplaySpeed = announcementBar.getAttribute('data-slide-autoplay-speed') || 2000;
        const $bar = $(announcementBar);
        const $prev = $(scope.querySelectorAll('[data-announcement-prev]'));
        const $next = $(scope.querySelectorAll('[data-announcement-next]'));
        const $toggle = $(scope.querySelectorAll('[data-announcement-toggle]'));

        $bar.slick({
          arrows: $prev.length > 0 && $next.length > 0,
          prevArrow: $prev,
          nextArrow: $next,
          dots: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          speed: slideSpeed,
          autoplaySpeed: autoplaySpeed,
          rows: 0,
          swipe: false,
          draggable: false,
          touchMove: false,
          pauseOnHover: false,
          pauseOnFocus: false,
        });

        if ($toggle.length) {
          $toggle.off('click.announcement').on('click.announcement', function() {
            // slickPause lets an in-flight transition finish, so pausing
            // mid-slide settles on the next message rather than snapping back.
            const pausing = !$toggle.hasClass('is-paused');
            if (pausing) {
              $bar.slick('slickPause');
            } else {
              $bar.slick('slickPlay');
            }
            $toggle
              .toggleClass('is-paused', pausing)
              .attr('aria-label', pausing ? 'Play announcements' : 'Pause announcements');
          });
        }
      }
    }

    // iOS fires resize before rotation layout settles, so slick's own
    // handler measures the old orientation and never re-measures — the
    // track ends up sized/translated for the previous width and the
    // slide text turns invisible (controls, unmanaged by slick, survive).
    // Re-measure once the layout has settled; setPosition only recomputes
    // dimensions and keeps the current slide and play/pause state.
    var resyncTimer;
    var resyncOnRotate = function() {
      clearTimeout(resyncTimer);
      resyncTimer = setTimeout(function() {
        var bar = document.querySelector('.announcement__content-wrapper.slick-initialized');
        if (bar) $(bar).slick('setPosition');
      }, 400);
    };
    window.addEventListener('orientationchange', resyncOnRotate);
    window.addEventListener('resize', resyncOnRotate);

    return Announcement;
  })();
  window.theme.sections.register('announcement', theme.Announcement);
  window.theme._registeredSections['announcement'] = true;
}
